import { DEFAULT_DATE_FORMAT as r } from "../components/atoms/Calender/calender.helper.js";
import { formatDate as n } from "../node_modules/date-fns/format.js";
import { ar as m } from "../node_modules/date-fns/locale/ar.js";
import { enUS as a } from "../node_modules/date-fns/locale/en-US.js";
const c = () => {
  const e = document.getElementById("storybook-preview-iframe");
  return e && e.ownerDocument ? e.ownerDocument.documentElement.lang : document.documentElement.lang;
}, D = (e, o = r) => {
  const t = (c() || "en") === "ar" ? m : a;
  return n(new Date(e), o, { locale: t });
};
export {
  D as formatDate,
  c as getLocale
};
//# sourceMappingURL=helper.js.map
